import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import ErrorMessage from '../../shared/ErrorMessage.js';
import LotProjectField from '../../shared/lots/LotProjectField.js';
import '../../weight/lots/WeightLots.css';

export const AddHerdLot = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [name,              setName]              = useState('');
  const [plans,             setPlans]             = useState([]);
  const [selectedPlanId,    setSelectedPlanId]    = useState('');
  const [projectIds,        setProjectIds]        = useState([]);
  const [errorMessage,      setErrorMessage]      = useState('');

  useEffect(() => {
    Fetch('api/data/lots.plans?search_fields=type&search_values=general', 'GET', null, (data) => setPlans(data || []));
    Fetch('api/data/account.settings', 'GET', null, (data) => {
      const id = data?.[0]?.default_herd_protocol_id;
      if (id) setSelectedPlanId(id);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');
    const body = JSON.stringify({
      type: 'herd',
      name: name.trim(),
      protocol_id: selectedPlanId || null,
      project_ids: projectIds,
    });
    Fetch('api/data/lots', 'post', body, (lot) => {
      onSuccess(lot);
    }, () => {
      setErrorMessage(t('error_creating_herd_lot'));
    });
  };

  return (
    <form className="wl-add-form" onSubmit={handleSubmit}>
      <div className="wl-form-group">
        <label>{t('herd_lot_name')}</label>
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder={t('herd_lot_name_placeholder')}
          maxLength={50}
        />
      </div>
      <div className="wl-form-group">
        <label>{t('lot_plan_optional')}</label>
        <select value={selectedPlanId} onChange={e => setSelectedPlanId(e.target.value)}>
          <option value="">-- {t('no_plan')} --</option>
          {plans.map(p => (
            <option key={p._id} value={p._id}>{p.name}</option>
          ))}
        </select>
      </div>
      <LotProjectField value={projectIds} onChange={setProjectIds} groupClassName="wl-form-group" />
      <button type="submit" className="wl-submit-btn">{t('add_button')}</button>
      <ErrorMessage message={errorMessage} />
    </form>
  );
};

export default AddHerdLot;
